// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fgtkf","col":"styles_col__85RoY"};